/* ---- SAMPLE LIMIT: only on CART (page or drawer) ---- */
(function () {
  function isCart() {
    return /\/cart(\/|$)/.test(location.pathname) ||
           document.querySelector('.cart__items, [data-cart], #CartDrawer, .cart-drawer');
  }
  if (!isCart()) return;

  var MAP = window.variantMaxQtyMap || {};
  function toInt(v, d){ v=parseInt(v,10); return isNaN(v) ? (d||0) : v; }

  function showLimitNotice(max) {
    var id = 'sample-limit-toast';
    var old = document.getElementById(id);
    if (old) old.remove();

    var toast = document.createElement('div');
    toast.id = id;
    toast.textContent = 'Solo puedes comprar ' + max + ' unidades de los productos de muestra.';
    toast.style.cssText = [
      'position:fixed',
      'left:50%',
      'bottom:24px',
      'transform:translateX(-50%)',
      'background:#111',
      'color:#fff',
      'padding:10px 14px',
      'border-radius:999px',
      'font-size:13px',
      'line-height:1.3',
      'z-index:99999',
      'box-shadow:0 8px 24px rgba(0,0,0,.18)',
      'opacity:0',
      'transition:opacity .2s ease, transform .2s ease',
      'pointer-events:none',
      'max-width:calc(100vw - 32px)',
      'white-space:nowrap'
    ].join(';');

    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
    });

    clearTimeout(window.__sampleLimitToastTimer);
    window.__sampleLimitToastTimer = setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(6px)';
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 220);
    }, 2200);
  }

  function getVid(row){
    if (!row) return null;

    var a = row.getAttribute('data-variant-id');
    if (a) return String(a);

    var link = row.querySelector('a[href*="variant="]')?.getAttribute('href');
    if (link) {
      var m = link.match(/variant=(\d+)/);
      if (m) return String(m[1]);
    }

    var hid = row.querySelector('input[name="id[]"], input[name="id"]');
    if (hid) return String(hid.value);

    var qty = row.querySelector('input[type="number"][name^="updates"], input[type="number"][name="updates[]"], quantity-input input[type="number"], input.quantity__input');
    if (qty && qty.id) {
      var mm = qty.id.match(/(\d{8,})/);
      if (mm) return String(mm[1]);
    }

    return null;
  }

  function clampInput(input, max, silent){
    var v = toInt(input.value, 0);
    if (v > max) {
      input.value = max;
      if (!silent) showLimitNotice(max);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (v < 1) input.value = 1;
  }

  function applyLimits(root){
    (root || document).querySelectorAll('li[id^="CartItem-"], .cart-item, [data-cart-item], cart-item, .drawer__cart-item, .cart-drawer__item').forEach(function(row){
      var vid = getVid(row);
      var max = MAP[vid];
      if (!max) return;

      var input =
        row.querySelector('input[type="number"][name^="updates"]') ||
        row.querySelector('input[type="number"][name="updates[]"]') ||
        row.querySelector('quantity-input input[type="number"]') ||
        row.querySelector('input.quantity__input');

      if (!input) return;

      input.setAttribute('max', max);
      clampInput(input, max, true);

      if (!input.__sampleLimitBound) {
        input.__sampleLimitBound = true;

        var onChange = function(){ clampInput(input, max, false); };
        input.addEventListener('input', onChange);
        input.addEventListener('change', onChange);

        row.querySelectorAll('button, a').forEach(function (el) {
          el.addEventListener('click', function(){
            setTimeout(onChange, 0);
          });
        });
      }
    });

    var form = document.querySelector('form[action="/cart"], form[action*="/cart"]');
    if (form && !form.__maxHooked){
      form.__maxHooked = true;
      form.addEventListener('submit', function () {
        document.querySelectorAll('li[id^="CartItem-"], .cart-item, [data-cart-item], cart-item, .drawer__cart-item, .cart-drawer__item').forEach(function(row){
          var vid = getVid(row), max = MAP[vid];
          if (!max) return;
          var input = row.querySelector('input[type="number"][name^="updates"], input[type="number"][name="updates[]"], quantity-input input[type="number"], input.quantity__input');
          if (input) clampInput(input, max, true);
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function(){ applyLimits(document); });

  new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes && m.addedNodes.forEach(function(n){
        if (n.nodeType===1) applyLimits(n);
      });
    });
  }).observe(document.documentElement, {childList:true, subtree:true});
})();

/* ---- SAMPLE LIMIT: only on PRODUCT PAGE ---- */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  var MAP = window.variantMaxQtyMap || {};
  function toInt(v, d){ v=parseInt(v,10); return isNaN(v) ? (d||0) : v; }

  function showLimitNotice(max) {
    var id = 'sample-limit-toast';
    var old = document.getElementById(id);
    if (old) old.remove();

    var toast = document.createElement('div');
    toast.id = id;
    toast.textContent = 'Solo puedes comprar ' + max + ' unidades de los productos de muestra.';
    toast.style.cssText = [
      'position:fixed',
      'left:50%',
      'bottom:24px',
      'transform:translateX(-50%)',
      'background:#111',
      'color:#fff',
      'padding:10px 14px',
      'border-radius:999px',
      'font-size:13px',
      'line-height:1.3',
      'z-index:99999',
      'box-shadow:0 8px 24px rgba(0,0,0,.18)',
      'opacity:0',
      'transition:opacity .2s ease, transform .2s ease',
      'pointer-events:none',
      'max-width:calc(100vw - 32px)',
      'white-space:nowrap'
    ].join(';');

    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
    });

    clearTimeout(window.__sampleLimitToastTimer);
    window.__sampleLimitToastTimer = setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(6px)';
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 220);
    }, 2200);
  }

  function qtyInputs() {
    return document.querySelectorAll(
      'quantity-input input[type="number"], ' +
      'input[type="number"][name="quantity"], ' +
      'input[type="number"][id*="Quantity"], ' +
      'input.quantity__input'
    );
  }

  function getVariantInput() {
    return document.querySelector('form[action*="/cart"] input[name="id"]') ||
           document.querySelector('input[name="id"]');
  }

  function getCurrentVariantId() {
    var idEl = getVariantInput();
    return idEl ? String(idEl.value) : null;
  }

  function applyForVariant(vid){
    var max = MAP[vid];

    qtyInputs().forEach(function(input){
      if (max) {
        input.removeAttribute('max');

        var v = toInt(input.value, 1);
        if (v > max) input.value = max;
        if (v < 1) input.value = 1;

        if (!input.__sampleClampBound) {
          input.__sampleClampBound = true;

          var clamp = function(){
            var currentVid = getCurrentVariantId();
            var currentMax = MAP[currentVid];
            if (!currentMax) return;

            var currentVal = toInt(input.value, 1);
            if (currentVal > currentMax) {
              input.value = currentMax;
              showLimitNotice(currentMax);
            }
            if (currentVal < 1) input.value = 1;
          };

          input.addEventListener('input', clamp);
          input.addEventListener('change', clamp);
        }
      } else {
        input.removeAttribute('max');
      }
    });
  }

  function bind(){
    var idEl = getVariantInput();
    if (!idEl) return;

    applyForVariant(idEl.value);

    if (!idEl.__sampleVariantBound) {
      idEl.__sampleVariantBound = true;

      idEl.addEventListener('change', function(){
        setTimeout(function(){ applyForVariant(idEl.value); }, 0);
      });

      new MutationObserver(function(){
        setTimeout(function(){ applyForVariant(idEl.value); }, 0);
      }).observe(idEl, { attributes:true, attributeFilter:['value'] });
    }

    document.querySelectorAll('quantity-input, .quantity, .product-form__quantity').forEach(function(box){
      if (box.__samplePlusBound) return;
      box.__samplePlusBound = true;

      box.addEventListener('click', function(e){
        var btn = e.target.closest('button, a');
        if (!btn) return;

        var input = box.querySelector('input[type="number"]') ||
                    document.querySelector('input[name="quantity"]') ||
                    document.querySelector('input.quantity__input');
        if (!input) return;

        var vid = getCurrentVariantId();
        var max = MAP[vid];
        if (!max) return;

        setTimeout(function(){
          var val = toInt(input.value, 1);
          if (val > max) {
            input.value = max;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
            showLimitNotice(max);
          }
          if (val === max) {
            showLimitNotice(max);
          }
        }, 0);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', bind);
  setTimeout(bind, 500);

  new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes && m.addedNodes.forEach(function(n){
        if (n.nodeType===1) {
          setTimeout(bind, 0);
        }
      });
    });
  }).observe(document.documentElement, {childList:true, subtree:true});
})();